import { Grid } from '@mui/material';
import React, { FC } from 'react';
import { PlanCardV2 } from 'views/rebranded-module/common/components/UI/PlanCardV2';
import StyledGrid from 'views/rebranded-module/common/components/UI/PlanCardList/PlanCardList.styles';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import Dinero from 'views/rebranded-module/common/utils/Dinero';
import moneyFormat from 'views/rebranded-module/common/utils/moneyFormat';

const PlanCardList: FC<any> = (props) => {
  const {
    content,
    plansData,
    cardActions,
    showRentalWord = true,
    handleJoinNowClick,
  } = props;

  const getButtonStyle = (index) => {
    if (index === 1) {
      return {
        buttonVariant: 'contained',
        buttonColor: 'primary',
        isSilver: true,
      };
    }
    return {
      buttonVariant: 'outlined',
      buttonColor: index === 0 ? 'secondary' : 'primary',
    };
  };

  const plans = plansData.map((plan: any, index) => {
    const rentalCredits =  plan.rental_credits_count;

    const buttonProps = getButtonStyle(index);
    const getFormattedPrice = (monthly_price) => {
      if (typeof monthly_price === 'string') {
        return monthly_price;
      }

      if (typeof monthly_price === 'object') {
        return moneyFormat(
          Dinero({
            amount: monthly_price.amount,
            currency: monthly_price.currency_code,
            precision: monthly_price.precision,
          }),
        );
      }

      return '';
    };
    return {
      id: plan.id,
      name: plan.name,
      price: getFormattedPrice(plan.monthly_price),
      rentalCredits,
      benefits:
        index === 0
          ? content.PlanCardComponent.firstPlanBenefits
          : index === 1
          ? content.PlanCardComponent.secondPlanBenefits
          : content.PlanCardComponent.thirdPlanBenefits,
      logo: plan.logo,
      planCTAButton: plan.name,
      isSilver: index === 1,
      buddyCount: plan.buddy_pass_count,
      initiationFee: plan.initiation_fee,
      ...buttonProps,
    };
  });
  console.log(plans);
  return (
    <StyledGrid
      container
      spacing={3}
      justifyContent="center"
      className="PCLGridContainer">
      {plans.map((plan) => (
        <Grid item xs={12} sm={12} md={12} lg={4} key={plan.name}>
          <PlanCardV2
            plan={plan}
            cardActions={cardActions}
            handleJoinNowBtnClick={handleJoinNowClick || null}
          />
        </Grid>
      ))}
    </StyledGrid>
  );
};

export { PlanCardList };
